/* eslint-disable no-restricted-imports */
import { Slider as MuiSlider, SliderProps as MuiSliderProps } from '@material-ui/core';
import { base } from 'omakase/Slider/sliderCssDefs';

import React from 'react';

export type SliderProps = MuiSliderProps;

const Slider: React.FunctionComponent<SliderProps> = (props) => <MuiSlider css={base} {...props} />;

export default Slider;
